module.exports = __webpack_public_path__ + "img/water_drop_black.025e46c9.svg";